function compareSortOrder({
  sortOrder: currentOrder = 0
}, {
  sortOrder: previousOrder = 0
}) {
  return Math.sign(currentOrder - previousOrder);
}
export default function sortByText(array) {
  return array.sort((current, previous) => {
    let order = compareSortOrder(current, previous);
    if (order === 0) {
      const lowerCaseCurrent = current.text.toLowerCase();
      const lowerCasePrevious = previous.text.toLowerCase();
      order = lowerCaseCurrent.localeCompare(lowerCasePrevious);
    }
    return order;
  });
}